import { render, staticRenderFns } from "./addOrEditIntegralShop.vue?vue&type=template&id=3400b50f&scoped=true"
import script from "./addOrEditIntegralShop.vue?vue&type=script&lang=js"
export * from "./addOrEditIntegralShop.vue?vue&type=script&lang=js"
import style0 from "./addOrEditIntegralShop.vue?vue&type=style&index=0&id=3400b50f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3400b50f",
  null
  
)

export default component.exports